<template>
  <div class="bg-white">
    <div
      class="fixed z-20 top-0 left-0 w-full flex justify-between items-center px-6 h-[72px]"
      :class="{
        'bg-white shadow-sm shadow-dark-500 h-14': isHeaderPanelActive,
      }"
    >
      <div class="cursor-pointer">
        <a href="/" class="block relative lg:w-auto">
          <SvgIcon v-if="isHeaderPanelActive" :name="logoShortSvgName" width="32" />
          <SvgIcon v-else :name="logoTxtWhiteSvgName" />
        </a>
      </div>
      <div>
        <a
          href="#"
          class="rounded border-2 border-primary bg-primary text-white text-button2 font-semibold py-1.5 px-2.5 hover:text-white"
          :class="isHeaderPanelActive ? 'inline-block' : 'hidden'"
          @click.prevent="scrollTop"
        >
          {{ t('register') }}
        </a>
        <a
          data-id="signup-signin"
          href="#"
          class="rounded border-2 ml-2 bg-transparent text-button2 font-semibold py-1.5 px-2.5 inline-block"
          :class="
            isHeaderPanelActive
              ? 'border-primary text-primary'
              : 'border-white text-white hover:text-white'
          "
          @click.prevent="signin"
        >
          {{ t('signIn') }}
        </a>
      </div>
    </div>

    <div
      class="z-10 top-0 left-0 absolute w-full h-full bg-cover px-6 pt-[72px] bg-no-repeat bg-center bg-home-main lg:static lg:h-screen"
    >
      <div class="flex flex-wrap items-center h-full">
        <div class="flex-[0_0_100%] max-w-full lg:flex-[0_0_50%] lg:max-w-1/2 h-full flex flex-col">
          <h1 class="text-headline4 font-semibold text-white mt-auto mb-auto">{{ t('title') }}</h1>

          <div>
            <FadeTransition>
              <div v-if="page === 'my-gender'" key="k1">
                <div class="text-headline5 font-semibold text-white mb-4 relative">
                  {{ t('header') }}
                </div>
                <div>
                  <button
                    data-id="signup-account-my-gender"
                    data-param-gender="male"
                    class="text-button1 font-semibold rounded bg-primary border-primary text-white w-full text-left mb-3 flex items-center justify-start p-4 h-16"
                    @click="setMyGenderMale"
                  >
                    {{ t('man') }}
                  </button>
                  <button
                    data-id="signup-account-my-gender"
                    data-param-gender="female"
                    class="text-button1 font-semibold rounded bg-secondary border-secondary text-white w-full text-left flex items-center justify-start p-4 h-16"
                    @click="setMyGenderFemale"
                  >
                    {{ t('woman') }}
                  </button>
                </div>
              </div>

              <div v-else-if="page === 'match-gender'" key="k2">
                <div class="text-headline5 font-semibold text-white mb-4 relative">
                  <a
                    href="#"
                    class="absolute left-0 -top-8"
                    data-test-id="btn_back"
                    @click.prevent="setPage('my-gender')"
                    ><i class="icon icon-arrow_left text-white text-[24px]"></i
                  ></a>
                  {{ t('headerLook') }}
                </div>
                <div>
                  <button
                    data-id="signup-account-match-gender"
                    data-param-gender="female"
                    class="text-button1 font-semibold rounded bg-secondary border-secondary text-white w-full text-left mb-3 flex items-center justify-start p-4 h-16"
                    @click="lookingForWoman"
                  >
                    {{ t('womanLook') }}
                  </button>
                  <button
                    data-id="signup-account-match-gender"
                    data-param-gender="male"
                    class="text-button1 font-semibold rounded bg-primary border-primary text-white w-full text-left flex items-center justify-start p-4 h-16"
                    @click="lookingForMan"
                  >
                    {{ t('manLook') }}
                  </button>
                </div>
              </div>

              <div v-else-if="page === 'continue'" key="k3">
                <div class="text-headline5 font-semibold text-white mb-4 relative">
                  <a
                    href="#"
                    class="absolute left-0 -top-8"
                    data-test-id="btn_back"
                    @click.prevent="setPage('match-gender')"
                    ><i class="icon icon-arrow_left text-white text-[24px]"></i
                  ></a>
                  {{ t('headerFaceBook') }}
                </div>
                <div>
                  <button
                    class="text-button1 font-semibold rounded w-full text-left flex items-center justify-start p-4 h-16 bg-facebook text-white border border-facebook"
                    @click="continueWithExternalProvider('facebook')"
                  >
                    <i class="icon icon-fb text-white !text-[32px] mr-3"></i>
                    {{ t('facebook') }}
                  </button>
                  <button
                    v-if="!isInFbWebView"
                    class="text-button1 font-semibold rounded bg-white text-dark-100 mb-0 w-full text-left mt-2 flex items-center justify-start p-4 h-16"
                    @click="continueWithExternalProvider('google')"
                  >
                    <SvgIcon class="mr-3" name="google" width="32" height="32" />
                    {{ t('google') }}
                  </button>
                  <button
                    class="text-button1 font-semibold rounded bg-white/10 text-dark-300 w-full text-left mt-2 flex items-center justify-start p-4 h-16"
                    @click="continueWithEmail"
                  >
                    <i class="icon icon-mail_solid text-white !text-[32px] mr-3"></i>
                    {{ t('mail') }}
                  </button>
                </div>
              </div>
            </FadeTransition>

            <div class="text-caption font-normal text-dark-100 mt-6 mb-4 flex">
              <i
                class="icon icon-chevron_down text-white w-auto h-auto !text-[16px] bg-transparent mr-2"
              ></i>
              {{ t('addText') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white px-6 absolute top-full mx-auto my-0 max-w-screen-lg lg:top-0 lg:relative">
      <div class="py-12 text-dark">
        <div class="flex flex-wrap">
          <div class="flex-[0_0_100%] max-w-full lg:flex-[0_0_33.3333333333%] lg:max-w-1/3">
            <h3 class="text-headline4 font-semibold text-dark mb-4">{{ t('aboutUsTitle') }}</h3>
          </div>
          <div class="flex-[0_0_100%] max-w-full lg:flex-[0_0_66.6666666667%] lg:max-w-2/3">
            <p class="mb-0 text-body1 font-normal">
              {{ t('aboutUsText') }}
            </p>

            <div class="mt-12 text-center">
              <img
                src="../../../src/assets/img/homepage/find-love-woman.png"
                class="max-w-full h-auto"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div class="py-12 text-dark border-t border-t-dark-500">
        <h1 class="text-headline4 font-semibold mb-12">{{ t('whyWork') }}</h1>
        <div class="lg:flex">
          <div class="lg:w-6/12 lg:pr-4">
            <p class="text-body1 font-normal mb-6">{{ t('whyWorkText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('advantagesTitle') }}</h2>
            <p class="text-body1 font-normal mb-2">{{ t('advantagesText') }}</p>
            <ol class="list-decimal text-body1 font-normal mb-6 pl-4">
              <li>{{ t('advantages1') }}</li>
              <li>{{ t('advantages2') }}</li>
              <li>{{ t('advantages3') }}</li>
            </ol>

            <img
              src="../../../src/assets/img/homepage/1.jpg"
              class="max-w-full h-auto mb-6"
              alt="Mature man and woman are sitting on the grass close to each other and smiling."
            />

            <h3 class="text-headline5 font-semibold mb-4">{{ t('togetherTitle') }}</h3>
            <p class="text-body1 font-normal mb-2">{{ t('togetherText1') }}</p>
            <p class="text-body1 font-normal mb-6">{{ t('togetherText2') }}</p>
          </div>
          <div class="lg:w-6/12 lg:pl-4">
            <h3 class="text-headline5 font-semibold mb-4">{{ t('howWorkTitle') }}</h3>
            <p class="text-body1 font-normal mb-2">{{ t('howWorkText') }}</p>
            <ol class="list-decimal text-body1 font-normal mb-6 pl-4">
              <li>{{ t('howWork1') }}</li>
              <li>{{ t('howWork2') }}</li>
              <li>{{ t('howWork3') }}</li>
              <li>{{ t('howWork4') }}</li>
              <li>{{ t('howWork5') }}</li>
              <li>{{ t('howWork6') }}</li>
              <li>{{ t('howWork7') }}</li>
              <li>{{ t('howWork8') }}</li>
            </ol>
            <img
              src="../../../src/assets/img/homepage/2.jpg"
              class="max-w-full h-auto mb-6"
              alt="A laughing woman embraces a man from behind on the beach.
"
            />
            <h3 class="text-headline5 font-semibold mb-4">{{ t('canGiveTitle') }}</h3>
            <p class="text-body1 font-normal mb-2">{{ t('canGiveText') }}</p>
            <p class="text-body1 font-normal">{{ t('goodLuck') }}</p>
          </div>
        </div>
      </div>

      <div class="py-12 text-dark border-t border-t-dark-500">
        <div class="flex flex-wrap">
          <div class="flex-[0_0_100%] max-w-full">
            <h3 class="text-headline4 font-semibold text-dark mb-12">{{ t('communication') }}</h3>
          </div>
          <div
            class="flex-[0_0_100%] max-w-full lg:flex lg:items-center lg:justify-center lg:flex-[0_0_33.3333333333%] lg:max-w-1/3 lg:mb-16"
          >
            <div class="bg-primary w-16 h-16 flex justify-center items-center mb-6 rounded-full">
              <i class="icon icon-free_enter text-white !text-[32px]"></i>
            </div>
          </div>
          <div
            class="flex-[0_0_100%] max-w-full lg:flex-[0_0_66.6666666667%] lg:max-w-2/3 lg:mb-16"
          >
            <h3 class="text-headline4 font-semibold text-dark mb-4">
              {{ t('freeRegistrationTitle') }}
            </h3>
            <p class="text-body1 font-normal mb-12 lg:mb-0">{{ t('freeRegistrationText') }}</p>
          </div>

          <div
            class="lg:flex lg:items-center lg:justify-center lg:flex-[0_0_33.3333333333%] lg:max-w-1/3 lg:mb-16"
          >
            <div class="bg-secondary w-16 h-16 flex justify-center items-center mb-6 rounded-full">
              <i class="icon icon-support text-white !text-[32px]"></i>
            </div>
          </div>
          <div class="flex-[0_0_100%] max-w-full lg:flex-[0_0_66.6666666667%] lg:max-w-2/3 lg:mb-0">
            <h3 class="text-headline4 font-semibold text-dark mb-4">
              {{ t('questionnaireTitle') }}
            </h3>
            <p class="text-body1 font-normal mb-0">{{ t('questionnaireText') }}</p>
          </div>
        </div>
      </div>

      <div class="py-12 text-dark border-t border-t-dark-500">
        <div class="rounded-lg pt-6 px-6 pb-8 text-primary bg-primary-500 mb-12">
          <div class="mb-4">
            <i class="icon icon-mma text-primary text-[32px]"></i>
          </div>
          <h5 class="text-headline6 font-semibold mb-2">{{ t('await') }}</h5>
          <p class="text-tag font-medium mb-6">{{ t('checkYourself') }}</p>
          <a
            href="#"
            class="text-button1 font-semibold py-3 px-6 rounded bg-primary border-primary text-primary-500 hover:text-primary-500 inline-block"
            >{{ t('getStarted') }}</a
          >
        </div>

        <div class="lg:flex lg:items-center">
          <div class="lg:w-2/4">
            <h3 class="text-headline4 font-semibold text-dark mb-4">{{ t('newStar') }}</h3>
            <p class="text-body1 font-normal mb-8">{{ t('newFriends') }}</p>
            <a
              href="#"
              class="text-button1 font-semibold py-3 px-6 rounded bg-primary border-primary text-white hover:text-white block w-full"
              >{{ t('getStarted') }}</a
            >
            <div class="mt-12 text-center">
              <img
                src="../../../src/assets/img/homepage/find-love-man.png"
                class="max-w-full h-auto"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div class="py-12 text-dark border-t border-t-dark-500">
        <div class="row">
          <div class="col-12 lg:flex-[0_0_33.3333333333%] lg:max-w-1/3">
            <div
              class="bg-success-500 text-success w-16 h-16 flex justify-center items-center mb-6 rounded-full"
            >
              <i class="icon icon-security text-success !text-[32px]"></i>
            </div>
            <h3 class="text-headline5 font-semibold mb-4">{{ t('safety') }}</h3>
            <p class="text-body1 font-normal mb-12">{{ t('safetyText') }}</p>
          </div>
          <div class="col-12 lg:flex-[0_0_33.3333333333%] lg:max-w-1/3">
            <div
              class="bg-premium-500 text-premium w-16 h-16 flex justify-center items-center mb-6 rounded-full"
            >
              <i class="icon icon-verification text-premium !text-[32px]"></i>
            </div>
            <h3 class="text-headline5 font-semibold mb-4">{{ t('profileChecks') }}</h3>
            <p class="text-body1 font-normal mb-12">{{ t('profileChecksText') }}</p>
          </div>
          <div class="col-12 lg:flex-[0_0_33.3333333333%] lg:max-w-1/3">
            <div
              class="bg-accent-500 text-accent w-16 h-16 flex justify-center items-center mb-6 rounded-full"
            >
              <i class="icon icon-support text-accent !text-[32px]"></i>
            </div>
            <h3 class="text-headline5 font-semibold mb-4">{{ t('supportTeam') }}</h3>
            <p class="text-body1 font-normal mb-12">{{ t('supportTeamText') }}</p>
          </div>
        </div>
      </div>

      <div class="py-12 text-dark border-t border-t-dark-500">
        <h1 class="text-headline4 font-semibold mb-12">{{ t('topPlatform') }}</h1>
        <div class="lg:flex">
          <div class="lg:w-6/12 lg:pr-4">
            <h2 class="text-headline5 font-semibold mb-4">{{ t('siteInfo') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('siteInfoText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('howSiteWork') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('howSiteWorkText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('freeDatingSite') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('freeDatingSiteText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('howFind') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('howFindText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('isDatingWork') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('isDatingWorkText') }}</p>
          </div>
          <div class="lg:w-6/12 lg:pl-4">
            <h2 class="text-headline5 font-semibold mb-4">{{ t('unpleasantIssues') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('unpleasantIssuesText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('completeProfile') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('completeProfileText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('startChatting') }}</h2>
            <p class="text-body1 font-normal mb-6">{{ t('startChattingText') }}</p>
            <h2 class="text-headline5 font-semibold mb-4">{{ t('firstDate') }}</h2>
            <p class="text-body1 font-normal">{{ t('firstDateText') }}</p>
          </div>
        </div>
      </div>

      <div class="bg-dark-500 p-6 block -mx-6 border-t border-t-dark-500">
        <div class="flex flex-wrap justify-between lg:justify-center">
          <button
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 lg:w-auto lg:mr-2.5"
            @click="openModal('privacy')"
          >
            {{ t('privacy') }}
          </button>
          <button
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 lg:w-auto lg:mr-2.5"
            @click="openModal('terms')"
          >
            {{ t('terms') }}
          </button>
          <a
            :href="faqUrl"
            target="_blank"
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 lg:w-auto lg:mr-2.5"
          >
            {{ t('faq') }}
          </a>
          <button
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 lg:w-auto lg:mr-2.5"
            @click="openModal('membership')"
          >
            {{ t('membership') }}
          </button>
          <button
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 lg:w-auto lg:mr-2.5"
            @click="openSupport"
          >
            {{ t('support') }}
          </button>
          <button
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 lg:w-auto lg:mr-2.5"
            @click="openModal('cookie')"
          >
            {{ t('cookie') }}
          </button>
          <a
            :href="blogUrl"
            target="_blank"
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 hover:text-dark-100 lg:w-auto lg:mr-2.5"
          >
            {{ t('blog') }}
          </a>
          <a
            :href="localDatingUrl"
            target="_blank"
            class="text-left text-caption font-normal text-dark-100 my-2 w-2/4 hover:text-dark-100 lg:w-auto"
          >
            {{ t('localDating') }}
          </a>
          <div class="text-left text-caption font-normal text-dark-100 my-2">
            {{ legalAddress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ProfileGender } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/profile/v1/profile_pb';
import { setLandingUrl } from '@project-gd-x/shared-web/src/helpers/landing-url/landing-url';
import { replaceLegalVariables } from '@project-gd-x/shared-web/src/helpers/legal-formatter/legal-formatter';
import { computed, onMounted, onUnmounted, ref } from 'vue';

import SvgIcon from '@/components/inputs/icon/svg-icon/SvgIcon.vue';
import { IconType } from '@/components/inputs/icon/svg-icon/types';
import FadeTransition from '@/components/transition/FadeTransition.vue';
import { getFaqUrl } from '@/helpers/faq/faq';
import { getConfig } from '@/helpers/mirror/mirror';
import { navigateToExternalAuth } from '@/helpers/navigator/navigator';
import * as scroll from '@/helpers/scroll/scroll';
import * as webview from '@/helpers/webview/webview';
import { useCountry } from '@/hooks/use-country/use-country';
import { pushRoute, resolveRoute } from '@/router';
import { ExternalUserInfoProvider } from '@/services/api/my-profile/helpers/type/type';
import { GetTextPageArgumentPageId } from '@/services/api/page/page-api';
import { useI18n } from '@/services/i18n';
import { openWidget } from '@/services/support/support';
import { SETTINGS_BLOG_URL, SETTINGS_LOCAL_DATING_URL } from '@/settings';
import { commit, getStore } from '@/store/store-helper';

import { messages } from './i18n';

type Page = 'my-gender' | 'match-gender' | 'continue';

const { t } = useI18n({ messages });

const isHeaderPanelActive = ref(false);
const page = ref<Page>('my-gender');
const legalAddress = ref('');
const faqUrl = getFaqUrl();
const blogUrl = SETTINGS_BLOG_URL;
const localDatingUrl = SETTINGS_LOCAL_DATING_URL;

const logoTxtWhiteSvgName = computed(() => {
  return getConfig().logoTxtWhiteSvgName as IconType;
});

const logoShortSvgName = computed(() => {
  return getConfig().logoShortSvgName as IconType;
});

const isInFbWebView = computed(() => {
  return webview.isInFacebookApp();
});

function setPage(pageArg: Page): void {
  page.value = pageArg;
}

function openModal(pageId: GetTextPageArgumentPageId) {
  pushRoute('textPage', { pageId });
}

function setMyGenderMale() {
  commit('mutationSignupSetMyProfileField', {
    gender: ProfileGender.MALE,
  });
  setPage('match-gender');
}

function setMyGenderFemale() {
  commit('mutationSignupSetMyProfileField', {
    gender: ProfileGender.FEMALE,
  });
  setPage('match-gender');
}

function scrollTop() {
  scroll.scrollTop();
}

function lookingForMan() {
  commit('mutationSignupSetMatchGender', ProfileGender.MALE);
  setPage('continue');
}

function lookingForWoman() {
  commit('mutationSignupSetMatchGender', ProfileGender.FEMALE);
  setPage('continue');
}

function continueWithEmail() {
  pushRoute('signupAccount');
}

function continueWithExternalProvider(provider: ExternalUserInfoProvider) {
  const { myProfile, matchProfile } = getStore().state.signup;

  navigateToExternalAuth(
    resolveRoute('externalAccount', {
      myGender: myProfile.gender === ProfileGender.MALE ? 'male' : 'female',
      matchGender: matchProfile.gender === ProfileGender.MALE ? 'male' : 'female',
      provider,
    }).fullPath,
    provider,
  );
}

function signin() {
  pushRoute('signin');
}

function openSupport() {
  openWidget();
}

function handleScroll() {
  isHeaderPanelActive.value = window.scrollY > 0;
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);

  const { country, load } = useCountry();
  load().then(() => {
    if (country.value) {
      legalAddress.value = replaceLegalVariables('{{company}}, {{address}}', {
        countryAlpha3: country.value?.country.isoCodeAlpha3,
      });
    }
  });

  setLandingUrl(window.location.href);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
